import React from 'react';

import { Box, Typography } from '@mui/material';

export type ListCellDataProps = {
    mainText?: string;
    secondaryText?: string;
    direction?: 'row' | 'column';
};

const ListCellData: React.FunctionComponent<ListCellDataProps> = function ({
    mainText,
    secondaryText,
    direction = 'row',
}) {
    const wrapperSx = {
        display: 'flex',
        flexDirection: direction,
        gap: direction === 'row' ? '0 5px' : '0 5px',
    };

    return (
        <Box>
            <Box sx={wrapperSx}>
                {mainText && (
                    <Typography
                        variant="l2dtableCell"
                        color="text.gris70"
                    >
                        {mainText}
                    </Typography>
                )}
            </Box>
            <Box sx={wrapperSx}>
                {secondaryText && (
                    <Typography
                        variant="l2dtableCell"
                        color="text.gris50"
                        fontSize="0.75rem"
                    >
                        {secondaryText}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default ListCellData;
